module.exports = __webpack_public_path__ + "img/stvrt-mapa.41d9a03b.jpg";